export const tryJsonParse = (jsonString) => {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    return jsonString;
  }
};
